<section id="pricing">
  <div class="container">
    <div class="pricing-header text-center" appReveal>
      <div class="sec-label">Planes</div>
      <h2 class="sec-title">Un plan a la medida de tu privada</h2>
      <p class="sec-sub mx-auto">Todos los planes incluyen soporte técnico y capacitación.</p>
    </div>
    <div class="row g-4">
      <div class="col-md-4">
        <div class="plan-glass h-100" appReveal>
          <h3>Básico</h3>
          <p class="pdesc">Ideal para fraccionamientos que inician su digitalización.</p>
          <hr>
          <div class="pinc">Incluye</div>
          <ul>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Control de pagos de mantenimiento</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Registro de gastos de la privada</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Control de visitas con QR</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Bitácora con fotografía (1 año)</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Chat, anuncios y encuestas</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Botón de pánico</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Reservación de amenidades</li>
          </ul>
          <a class="pbtn pbtn-outline mt-auto" [routerLink]="['/']" [fragment]="'contact'">Solicitar información</a>
        </div>
      </div>
      <div class="col-md-4">
        <div class="plan-glass popular h-100" appReveal>
          <div class="popular-tag">Más popular</div>
          <h3>Premium</h3>
          <p class="pdesc">Ideal para automatización de accesos para visitas.</p>
          <hr>
          <div class="pinc">Todo lo de Básico más</div>
          <ul>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Bitácora con fotografía (2 años)</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Automatización de accesos para visitas</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Conexión con cámaras IP</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Apertura remota desde la app</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Panel para lectores QR y barreras</li>
          </ul>
          <a class="pbtn pbtn-white mt-auto" [routerLink]="['/']" [fragment]="'contact'">Solicitar información</a>
        </div>
      </div>
      <div class="col-md-4">
        <div class="plan-glass h-100" appReveal>
          <h3>Plata</h3>
          <p class="pdesc">Ideal para automatización de accesos de visitas y residentes.</p>
          <hr>
          <div class="pinc">Todo lo de Premium más</div>
          <ul>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Bitácora con fotografía (5 años)</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Automatización visitas y residentes</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Lectores QR, RFID y UHF</li>
            <li><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Consulta de accesos (5 años)</li>
          </ul>
          <a class="pbtn pbtn-outline mt-auto" [routerLink]="['/']" [fragment]="'contact'">Solicitar información</a>
        </div>
      </div>
    </div>
    <p class="pricing-note text-center mt-4">* La instalación de hardware no está incluida.</p>
  </div>
</section>
